'use client'

import { clsx } from 'clsx'
import { motion } from 'framer-motion'
import Image from 'next/image'

export function Logo({ className }) {
  let transition = {
    duration: 0.5,
    ease: 'easeInOut',
  }

  return (
    <motion.div
      variants={{ idle: {}, active: {} }}
      initial="idle"
      whileHover="active"
      className={clsx(className, 'overflow-visible')}
    >
      <motion.div
        variants={{
          idle: { scale: 1, opacity: 1 },
          active: {
            scale: [1, 1.15, 1],
            opacity: [1, 0.75, 1],
            transition: {
              ...transition,
              delay: 0,
            },
          },
        }}
      >
        <Image
          src="/assets/ms.png"
          alt="Saisha Consultancy Logo"
          width={48}
          height={48}
          className="w-auto h-auto rounded-sm"
        />
      </motion.div>
    </motion.div>
  )
}

export function Mark({ className }) {
  return (
    <Image
      src="/assets/ms.png"
      alt="Saisha Consultancy Mark"
      width={40}
      height={40}
      className={className}
    />
  )
}
